(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["careers-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  const root = document.querySelector('[data-stanlee-careers]');
  if (!root) return;

  /* Scroll reveal */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    root.querySelectorAll('[data-reveal]').forEach((el) => io.observe(el));
  } else {
    root.querySelectorAll('[data-reveal]').forEach((el) => el.classList.add('is-visible'));
  }

  /* Smooth scroll from hero CTA to form */
  root.querySelectorAll('[data-scroll-to-form]').forEach((link) => {
    link.addEventListener('click', (e) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* Upload box */
  root.querySelectorAll('[data-upload]').forEach((wrap) => {
    const input = wrap.querySelector('[data-upload-input]');
    const box = wrap.querySelector('[data-upload-box]');
    const filename = wrap.querySelector('[data-upload-filename]');
    const defaultLabel = filename.textContent;
    box.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); input.click(); }
    });
    input.addEventListener('change', () => {
      if (input.files && input.files[0]) {
        filename.textContent = input.files[0].name;
        wrap.classList.add('has-file');
      } else {
        filename.textContent = defaultLabel;
        wrap.classList.remove('has-file');
      }
    });
  });

  /* Form handling */
  const form = root.querySelector('[data-careers-form]');
  if (!form) return;

  const MAX_FILE_MB = parseInt(form.getAttribute('data-max-file-mb'), 10) || 5;
  const submitBtn = form.querySelector('[data-careers-submit]');
  const submitLabel = form.querySelector('[data-submit-label]');
  const spinner = form.querySelector('[data-submit-spinner]');
  const successEl = root.querySelector('[data-careers-success]');
  const globalError = root.querySelector('[data-careers-form-error]');

  const urlPattern = /^https?:\/\/[^\s]+\.[^\s]+$/i;
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function setFieldError(name, message) {
    const errorEl = form.querySelector('[data-error-for="' + name + '"]');
    const field = form.querySelector('[name="' + name + '"]');
    if (errorEl) errorEl.textContent = message || '';
    if (field) {
      const container = field.closest('.stanlee-careers__field') || field.closest('.stanlee-careers__upload');
      if (container) container.classList.toggle('has-error', !!message);
    }
  }

  function clearErrors() {
    form.querySelectorAll('[data-error-for]').forEach((el) => (el.textContent = ''));
    form.querySelectorAll('.has-error').forEach((el) => el.classList.remove('has-error'));
    globalError.hidden = true;
    globalError.textContent = '';
  }

  function validate() {
    clearErrors();
    let firstInvalid = null;
    let valid = true;

    const required = {
      'fi-sender-fullName': 'Please enter your full name.',
      'fi-sender-email': 'Please enter your email address.',
      'fi-sender-phone': 'Please enter your phone number.',
      'fi-sender-city': 'Please enter your current location.',
      'fi-text-current_role': 'Please tell us which role you are applying for.',
      'fi-text-why_hire': 'Please tell us why we should hire you.',
    };
    Object.keys(required).forEach((name) => {
      const field = form.querySelector('[name="' + name + '"]');
      if (field && !field.value.trim()) {
        setFieldError(name, required[name]);
        if (!firstInvalid) firstInvalid = field;
        valid = false;
      }
    });

    const emailField = form.querySelector('[name="fi-sender-email"]');
    if (emailField && emailField.value.trim() && !emailPattern.test(emailField.value.trim())) {
      setFieldError('fi-sender-email', 'Please enter a valid email address.');
      if (!firstInvalid) firstInvalid = emailField;
      valid = false;
    }

    ['fi-url-linkedin', 'fi-url-portfolio'].forEach((name) => {
      const field = form.querySelector('[name="' + name + '"]');
      if (field && field.value.trim() && !urlPattern.test(field.value.trim())) {
        setFieldError(name, 'Please enter a valid URL (starting with http:// or https://).');
        if (!firstInvalid) firstInvalid = field;
        valid = false;
      }
    });

    const resumeInput = form.querySelector('[name="fi-file-resume"]');
    const file = resumeInput && resumeInput.files && resumeInput.files[0];
    if (!file) {
      setFieldError('fi-file-resume', 'Please attach your resume.');
      if (!firstInvalid) firstInvalid = resumeInput;
      valid = false;
    } else {
      const okType = /\.(pdf|doc|docx)$/i.test(file.name);
      if (!okType) {
        setFieldError('fi-file-resume', 'Please upload a PDF, DOC or DOCX file.');
        if (!firstInvalid) firstInvalid = resumeInput;
        valid = false;
      } else if (file.size > MAX_FILE_MB * 1024 * 1024) {
        setFieldError('fi-file-resume', 'File is too large. Max size is ' + MAX_FILE_MB + 'MB.');
        if (!firstInvalid) firstInvalid = resumeInput;
        valid = false;
      }
    }

    if (firstInvalid) firstInvalid.focus();
    return valid;
  }

  /*
    Forminit (the configured backend) is a block-based API: it only recognizes
    fields named "fi-{blockType}-{name}" (e.g. fi-sender-email, fi-file-resume) —
    plain field names like "email" or "resume" are not understood, which was the
    actual cause of every previous submission failure. Forminit's own documented
    client-side integration path is its CDN SDK (forminit.submit(formId, formData)),
    which performs the real HTTP request and only resolves with error === null when
    Forminit genuinely accepts the submission — so this is not a shortcut around
    checking the real result, it's the correct place to check it for this API.
    The SDK script is loaded dynamically here (not via a static <script> tag) so
    submission never depends on tag ordering elsewhere on the page.
  */
  const FORMINIT_SDK_URL = 'https://forminit.com/sdk/v1/forminit.js';
  let forminitSdkPromise = null;
  function loadForminitSdk() {
    if (window.Forminit) return Promise.resolve();
    if (forminitSdkPromise) return forminitSdkPromise;
    forminitSdkPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = FORMINIT_SDK_URL;
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('Forminit SDK failed to load'));
      document.head.appendChild(script);
    });
    return forminitSdkPromise;
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    const formId = form.getAttribute('data-forminit-form-id');
    if (!formId) {
      globalError.hidden = false;
      globalError.textContent = "We couldn't submit your application. Please try again in a moment, or email your application to us directly.";
      return;
    }

    if (form.querySelector('[name="company_website"]').value) {
      // honeypot triggered — silently drop
      return;
    }

    if (!validate()) return;

    submitBtn.disabled = true;
    submitLabel.textContent = 'Submitting…';
    spinner.hidden = false;
    globalError.hidden = true;

    const formData = new FormData(form);
    // The honeypot field isn't a recognized Forminit block; drop it before sending.
    formData.delete('company_website');

    loadForminitSdk()
      .then(() => {
        const forminit = new window.Forminit();
        return forminit.submit(formId, formData);
      })
      .then((result) => {
        if (result && result.error) throw new Error(result.error.message || 'Submission failed');
        successEl.hidden = false;
        submitBtn.disabled = true;
        submitLabel.textContent = 'Application Submitted';
        spinner.hidden = true;
        successEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      })
      .catch(() => {
        globalError.hidden = false;
        globalError.textContent = "We couldn't submit your application right now. Please try again.";
        submitBtn.disabled = false;
        submitLabel.textContent = 'Submit Application';
        spinner.hidden = true;
      });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["exchange-repair-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var toggleGroup = document.querySelector('[data-xr-toggle-group]');
    if (!toggleGroup) return;

    var dependentWrap = document.querySelector('[data-xr-dependent]');
    if (!dependentWrap) return;

    var dependentFields = dependentWrap.querySelectorAll('[data-xr-dependent-field]');
    var radios = toggleGroup.querySelectorAll('input[type="radio"]');

    function setState(isYes) {
      dependentFields.forEach(function (field) {
        if (isYes) {
          field.disabled = false;
          field.required = true;
          field.closest('.xr-field').style.opacity = '';
        } else {
          field.disabled = true;
          field.required = false;
          field.value = '';
          field.closest('.xr-field').style.opacity = '0.55';
        }
      });
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        setState(radio.dataset.xrToggle === 'yes');
      });
    });

    // Default: dependent fields inactive until "Yes" is chosen.
    setState(false);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function () {
  const nav = document.querySelector('[data-stanlee-nav]');
  if (!nav) return;

  const onScroll = () => {
    if (window.scrollY > 40) nav.classList.add('is-scrolled');
    else nav.classList.remove('is-scrolled');
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  const searchTrigger = document.querySelector('[data-search-trigger]');
  const searchPanel = document.querySelector('[data-search-panel]');
  const searchClose = document.querySelector('[data-search-close]');
  searchTrigger && searchTrigger.addEventListener('click', () => {
    const active = searchPanel.classList.toggle('is-active');
    searchTrigger.setAttribute('aria-expanded', active);
    if (active) searchPanel.querySelector('input[type="search"]').focus();
  });
  searchClose && searchClose.addEventListener('click', () => {
    searchPanel.classList.remove('is-active');
    searchTrigger.setAttribute('aria-expanded', 'false');
  });

  const mobileTrigger = document.querySelector('[data-mobile-trigger]');
  const mobilePanel = document.querySelector('[data-mobile-panel]');
  const mobileOverlay = document.querySelector('[data-mobile-overlay]');
  const mobileClose = document.querySelector('[data-mobile-close]');
  const openMobile = () => { mobilePanel.classList.add('is-active'); mobileOverlay.classList.add('is-active'); document.body.style.overflow = 'hidden'; };
  const closeMobile = () => { mobilePanel.classList.remove('is-active'); mobileOverlay.classList.remove('is-active'); document.body.style.overflow = ''; };
  mobileTrigger && mobileTrigger.addEventListener('click', openMobile);
  mobileClose && mobileClose.addEventListener('click', closeMobile);
  mobileOverlay && mobileOverlay.addEventListener('click', closeMobile);

  document.querySelectorAll('[data-accordion-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.stanlee-mobile-accordion');
      const panel = item.querySelector('[data-accordion-panel]');
      const isOpen = item.classList.toggle('is-open');
      panel.style.maxHeight = isOpen ? panel.scrollHeight + 'px' : '0px';
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  const nav = document.querySelector('[data-stanlee-nav]');
  if (!nav) return;

  const onScroll = () => {
    if (window.scrollY > 40) nav.classList.add('is-scrolled');
    else nav.classList.remove('is-scrolled');
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  const searchTrigger = document.querySelector('[data-search-trigger]');
  const searchPanel = document.querySelector('[data-search-panel]');
  const searchClose = document.querySelector('[data-search-close]');
  searchTrigger && searchTrigger.addEventListener('click', () => {
    const active = searchPanel.classList.toggle('is-active');
    searchTrigger.setAttribute('aria-expanded', active);
    if (active) searchPanel.querySelector('input[type="search"]').focus();
  });
  searchClose && searchClose.addEventListener('click', () => {
    searchPanel.classList.remove('is-active');
    searchTrigger.setAttribute('aria-expanded', 'false');
  });

  const mobileTrigger = document.querySelector('[data-mobile-trigger]');
  const mobilePanel = document.querySelector('[data-mobile-panel]');
  const mobileOverlay = document.querySelector('[data-mobile-overlay]');
  const mobileClose = document.querySelector('[data-mobile-close]');
  const openMobile = () => { mobilePanel.classList.add('is-active'); mobileOverlay.classList.add('is-active'); document.body.style.overflow = 'hidden'; };
  const closeMobile = () => { mobilePanel.classList.remove('is-active'); mobileOverlay.classList.remove('is-active'); document.body.style.overflow = ''; };
  mobileTrigger && mobileTrigger.addEventListener('click', openMobile);
  mobileClose && mobileClose.addEventListener('click', closeMobile);
  mobileOverlay && mobileOverlay.addEventListener('click', closeMobile);

  document.querySelectorAll('[data-accordion-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.stanlee-mobile-accordion');
      const panel = item.querySelector('[data-accordion-panel]');
      const isOpen = item.classList.toggle('is-open');
      panel.style.maxHeight = isOpen ? panel.scrollHeight + 'px' : '0px';
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  const hero = document.querySelector('[data-stanlee-hero]');
  if (!hero) return;

  const media = hero.querySelector('[data-hero-parallax]');
  const spotlight = hero.querySelector('[data-hero-spotlight]');
  const content = hero.querySelector('[data-hero-content]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Background parallax + spotlight — reduced to a subtle 6px range (was 18px) */
  if (!reduceMotion) {
    hero.addEventListener('mousemove', (e) => {
      const rect = hero.getBoundingClientRect();
      const px = (e.clientX - rect.left) / rect.width;
      const py = (e.clientY - rect.top) / rect.height;

      if (spotlight) {
        spotlight.style.setProperty('--x', (px * 100) + '%');
        spotlight.style.setProperty('--y', (py * 100) + '%');
      }
      if (media) {
        const moveX = (px - 0.5) * 6;
        const moveY = (py - 0.5) * 6;
        media.style.transform = `scale(1.06) translate(${moveX}px, ${moveY}px)`;
      }
    });
  }

  document.querySelectorAll('[data-smooth-scroll]').forEach((el) => {
    el.addEventListener('click', (e) => {
      const targetSel = el.getAttribute('data-scroll-target') || el.getAttribute('href');
      const target = targetSel && document.querySelector(targetSel);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* Magnetic buttons — barely-there movement (was up to 0.35, now a flat 0.06) */
  if (!reduceMotion) {
    document.querySelectorAll('[data-magnetic]').forEach((btn) => {
      btn.addEventListener('mousemove', (e) => {
        const rect = btn.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;
        btn.style.transform = `translate(${x * 0.06}px, ${y * 0.06}px)`;
      });
      btn.addEventListener('mouseleave', () => { btn.style.transform = ''; });
    });
  }

  /* Smooth fade + rise as the hero scrolls out of view, instead of an abrupt cutoff.
     Opacity eases from 1 -> 0.4 and the content lifts translateY(0 -> -60px)
     over the hero's own height. */
  if (!reduceMotion && content) {
    let ticking = false;

    const updateOnScroll = () => {
      const heroHeight = hero.offsetHeight || 1;
      const scrolled = Math.min(Math.max(window.scrollY, 0), heroHeight);
      const progress = scrolled / heroHeight;
      const opacity = Math.max(1 - progress * 0.6, 0.4);
      const translateY = progress * -60;
      content.style.opacity = opacity.toFixed(3);
      content.style.transform = `translateY(${translateY.toFixed(1)}px)`;
      ticking = false;
    };

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          window.requestAnimationFrame(updateOnScroll);
          ticking = true;
        }
      },
      { passive: true }
    );

    updateOnScroll();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stanlee-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  const nav = document.querySelector('[data-stanlee-nav]');
  if (!nav) return;

  const onScroll = () => {
    if (window.scrollY > 40) nav.classList.add('is-scrolled');
    else nav.classList.remove('is-scrolled');
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  const searchTrigger = document.querySelector('[data-search-trigger]');
  const searchPanel = document.querySelector('[data-search-panel]');
  const searchClose = document.querySelector('[data-search-close]');
  searchTrigger && searchTrigger.addEventListener('click', () => {
    const active = searchPanel.classList.toggle('is-active');
    searchTrigger.setAttribute('aria-expanded', active);
    if (active) searchPanel.querySelector('input[type="search"]').focus();
  });
  searchClose && searchClose.addEventListener('click', () => {
    searchPanel.classList.remove('is-active');
    searchTrigger.setAttribute('aria-expanded', 'false');
  });

  const mobileTrigger = document.querySelector('[data-mobile-trigger]');
  const mobilePanel = document.querySelector('[data-mobile-panel]');
  const mobileOverlay = document.querySelector('[data-mobile-overlay]');
  const mobileClose = document.querySelector('[data-mobile-close]');
  const openMobile = () => { mobilePanel.classList.add('is-active'); mobileOverlay.classList.add('is-active'); document.body.style.overflow = 'hidden'; };
  const closeMobile = () => { mobilePanel.classList.remove('is-active'); mobileOverlay.classList.remove('is-active'); document.body.style.overflow = ''; };
  mobileTrigger && mobileTrigger.addEventListener('click', openMobile);
  mobileClose && mobileClose.addEventListener('click', closeMobile);
  mobileOverlay && mobileOverlay.addEventListener('click', closeMobile);

  document.querySelectorAll('[data-accordion-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.stanlee-mobile-accordion');
      const panel = item.querySelector('[data-accordion-panel]');
      const isOpen = item.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', isOpen);
      panel.style.maxHeight = isOpen ? panel.scrollHeight + 'px' : '0px';
    });
  });

  /*
    PART 4/5 FIX: assets/stanlee-navigation.js (the single centralized
    controller for every category link on the site — mega menu, mobile
    accordion, and the Hero's Explore Products button) dispatches this
    event right before it scrolls the page and activates a tab. The
    header owns the mobile-menu/mega-menu DOM here, so it's the one
    that closes them — this keeps the closing logic in one place
    instead of duplicating it inside stanlee-navigation.js.
  */
  document.addEventListener('stanlee:close-menus', () => {
    closeMobile();
    document.querySelectorAll('.stanlee-nav__has-mega').forEach((item) => {
      item.classList.add('is-force-closed');
      window.setTimeout(() => item.classList.remove('is-force-closed'), 700);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stanlee-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  const hero = document.querySelector('[data-stanlee-hero]');
  if (!hero) return;

  const media = hero.querySelector('[data-hero-parallax]');
  const spotlight = hero.querySelector('[data-hero-spotlight]');
  const content = hero.querySelector('[data-hero-content]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Background parallax + spotlight — reduced to a subtle 6px range (was 18px) */
  if (!reduceMotion) {
    hero.addEventListener('mousemove', (e) => {
      const rect = hero.getBoundingClientRect();
      const px = (e.clientX - rect.left) / rect.width;
      const py = (e.clientY - rect.top) / rect.height;

      if (spotlight) {
        spotlight.style.setProperty('--x', (px * 100) + '%');
        spotlight.style.setProperty('--y', (py * 100) + '%');
      }
      if (media) {
        const moveX = (px - 0.5) * 6;
        const moveY = (py - 0.5) * 6;
        media.style.transform = `scale(1.06) translate(${moveX}px, ${moveY}px)`;
      }
    });
  }

  /* Generic smooth-scroll — only bound to elements WITHOUT data-category-link
     (e.g. the scroll-cue arrow), so the Explore Products button below is
     never handled by two listeners at once. */
  document.querySelectorAll('[data-smooth-scroll]:not([data-category-link])').forEach((el) => {
    el.addEventListener('click', (e) => {
      const targetSel = el.getAttribute('data-scroll-target') || el.getAttribute('href');
      const target = targetSel && document.querySelector(targetSel);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* Magnetic buttons — barely-there movement (was up to 0.35, now a flat 0.06) */
  if (!reduceMotion) {
    document.querySelectorAll('[data-magnetic]').forEach((btn) => {
      btn.addEventListener('mousemove', (e) => {
        const rect = btn.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;
        btn.style.transform = `translate(${x * 0.06}px, ${y * 0.06}px)`;
      });
      btn.addEventListener('mouseleave', () => { btn.style.transform = ''; });
    });
  }

  /* Smooth fade + rise as the hero scrolls out of view, instead of an abrupt cutoff.
     Opacity eases from 1 -> 0.4 and the content lifts translateY(0 -> -60px)
     over the hero's own height. */
  if (!reduceMotion && content) {
    let ticking = false;

    const updateOnScroll = () => {
      const heroHeight = hero.offsetHeight || 1;
      const scrolled = Math.min(Math.max(window.scrollY, 0), heroHeight);
      const progress = scrolled / heroHeight;
      const opacity = Math.max(1 - progress * 0.6, 0.4);
      const translateY = progress * -60;
      content.style.opacity = opacity.toFixed(3);
      content.style.transform = `translateY(${translateY.toFixed(1)}px)`;
      ticking = false;
    };

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          window.requestAnimationFrame(updateOnScroll);
          ticking = true;
        }
      },
      { passive: true }
    );

    updateOnScroll();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
